import { Typography, withTypographyContainer } from 'shared/ui/typography';
import { BasicCard, TVariant } from '../basicCard';
import { TextContainer } from './styles';
import { FC, ReactNode } from 'react';

interface InfoFieldCardProps {
	variant?: TVariant;
	title?: string;
	children?: ReactNode;
	styles?: {
		textAlign?: string;
		padding?: string;
		paddingCard?: string;
	};
}

export const InfoFieldCard: FC<InfoFieldCardProps> = ({
	variant = 'main',
	title = '',
	children,
	styles = {
		textAlign: '',
		padding: '',
		paddingCard: '',
	},
}) => {
  const EnhancedTypography = withTypographyContainer(Typography);

	return (
		<div>
			<EnhancedTypography mode="small">{title}</EnhancedTypography>
			{children ? (
				<BasicCard
					variant={variant}
					styles={{ padding: styles?.paddingCard }}
				>
					<TextContainer
						$padding={styles.padding}
						$textAlign={styles.textAlign}
					>
						<Typography whiteSpace="break-spaces" wordBreak="break-all">{children || '—'}</Typography>
					</TextContainer>
				</BasicCard>
			) : (
				<Typography style={{ marginLeft: '12px' }}>—</Typography>
			)}
		</div>
	);
};
